<template>
  <v-layout v-if="dialog" row justify-center>
    <v-dialog v-model="dialog" :max-width="maxWidth" scrollable>
      <v-card class="pa-2">
        <v-card-title v-if="!isNil(title)" class="headline px-2">
          <slot name="title">{{ title }}</slot>
        </v-card-title>
        <v-card-text>
          <slot name="body">{{ message }}</slot>
        </v-card-text>
        <v-card-actions>
          <slot name="actions">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" flat @click.native="close">{{ cancelText }}</v-btn>
            <v-btn color="primary" dark @click.native="submit" :loading="loading">{{ submitText }}</v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { isNil } from '../libs/utils'
export default {
  props: {
    maxWidth: { type: [Number, String], default: '80%' },
    cancelText: { type: String, default: 'Cancel' },
    submitText: { type: String, default: 'Submit' },
    title: { type: String, default: 'Title' },
    message: { type: String, default: '' }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      state: {
        promise: Promise.resolve(),
        resolve: () => {},
        reject: () => {}
      }
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        this.state.resolve(false)
      }
    }
  },
  methods: {
    isNil,
    async show () {
      this.dialog = true
    },
    async close () {
      this.dialog = false
      this.$emit('close', this)
    },
    async submit () {
      this.state.resolve(true)
      this.$emit('submit', this)
      await this.close()
    },
    async activate () {
      this.state.promise = new Promise((resolve, reject) => {
        this.state.resolve = resolve
        this.state.reject = reject
      }).then(async r => {
        await this.close()
        return r
      })
      await this.show()
      return this.state
    }
  }
}
</script>

